// extracted by mini-css-extract-plugin
export default {"formHeading":"VJ-z","form":"WJ-z","submitBtn":"XJ-z","disabled":"YJ-z","input":"ZJ-z","error":"_J-z","submitMsg":"aK-z","signIn":"bK-z"};